import React, { useContext } from "react";
import { GateInContext } from "../GateInView";
import { SideMenu } from "../../../../components/sideMenu/SideMenu";
import "./gateIn.css";
import ContentFile from "../../../../constants/contentFile.json";
import DetailsCard from "../../../../components/DetailsCard/DetailsCard";
import Button from "../../../../components/ButtonComponent/Button";
import PhotoUpload from "../../../../components/PhotoUploadComponent/PhotoUpload";
import { InputBox } from "../../../../components/InputField/inputFiled";
import AlertBox from "../../../../components/alertComponent/AlertBox";
import Spinner from "../../../../components/spinner/Spinner"
const GateIn = () => {
  const {
    vehicleNumber,
    onChangeVehicleNumber,
    onSubmitGateIn,
    errorMsg,
    capturedImage,
    handleCapturedImage,
    isButtonEnabled,
    imageErrorMsg,
    details,
    popUpMessages,
    errorAlert,
    setErrorAlert,
    successAlert,
    setSuccessAlert,
    naviagteToGateOut,
    apiStatus,
  } = useContext(GateInContext);

  const Contents = ContentFile.gateInOutPage;

  return (
    <div className="mainContainerDetail gateInContainer">
      <div className="itemBoxDetail">
        <div className="col-xl-11 col-lg-11 col-md-12 col-sm-12 col-10 mainBoxDetail">
          {apiStatus === "fetching" ? <Spinner /> : null}
          <h5 className="titleDetail">{Contents.gateIn}</h5>
          <DetailsCard details={details} />
          <h5 className="titleDetail">{Contents.vehicleNumber}</h5>
          <InputBox
            value={vehicleNumber}
            onChange={(event) => {
              onChangeVehicleNumber(event.target.value);
            }}
          />
          {errorMsg && <p className="errorText">{errorMsg}</p>}

          <PhotoUpload
            onImageCapture={handleCapturedImage}
            isSectionEnabled={isButtonEnabled}
          />
          {imageErrorMsg && <p className="errorText">{imageErrorMsg}</p>}

          {capturedImage && <p>{Contents.imageUploadMessage}</p>}
          <Button text={Contents.gateIn} onClick={onSubmitGateIn} />
        </div>
      </div>
      <AlertBox
        show={errorAlert}
        setShow={setErrorAlert}
        title={"Error"}
        alertMessage={popUpMessages}
      />
      <AlertBox
        show={successAlert}
        setShow={setSuccessAlert}
        title={"Success"}
        alertMessage={popUpMessages}
        buttonSubmitText="Ok"
        okFunction={naviagteToGateOut}
      />
    </div>
  );
};

export default GateIn;
